import { useEffect } from "react";
import { useDispatch } from "react-redux";
// pages
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as _ser from "../../../_redux/_services/ApplicantsSlice";
import { setBreadCrumb } from "../../../_utilities/breadCrumb";
import { getWorkonDate } from "../../../_utilities/GetTimeZone";
import { getUserDetails, GetUserInfo } from "../../../_utilities/getUserInfo";
import "./ApplicantsTable.css";
import Cookies from "js-cookie";
import { setSelectedApplicant } from "../../../_redux/SelectedApplicantSlice";

const initalState = { data: null, message: "", isloader: true };

const getApplicantPath = () =>
  Cookies.get("applicantViewPreference") || "/ats/layout/applicants/landing";

const ApplicantsManualUploadPopup = ({
  skipId,
  isAssociatedApplicant,
  updateProfileWithNewResume,
  sourceId,
  defaultFile,
  applicantCode,
  setDuplicateApplicatsConfirmPopup,
  jobId = null,
}) => {
  useEffect(() => {
    console.log(jobId);
  }, [jobId]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onDuplicateUploadHandler = async (type) => {
    let subpathName = `${updateProfileWithNewResume?.Applicants?.firstName} ${updateProfileWithNewResume?.Applicants?.lastName}`;
    let workExpObj =
      typeof updateProfileWithNewResume.workExp === "string"
        ? JSON.parse(updateProfileWithNewResume?.workExp)
        : updateProfileWithNewResume?.workExp;
    let designation =
      workExpObj?.length > 0
        ? `${workExpObj[0]?.jobTitle || ""}${workExpObj[0]?.organization ? " / " + workExpObj[0]?.organization : ""}`
        : "";
    let expObject = workExpObj[0]?.experienceInMonths
      ? workExpObj[0]?.experienceInMonths
      : {
          startDate: workExpObj[0]?.startDate,
          endDate: Boolean(workExpObj[0]?.isCurrent)
            ? "present"
            : workExpObj[0]?.endDate,
        };
    let additionalData = {
      applicantName: subpathName,
      currentWorking: {
        designation: designation,
        from: getWorkonDate(expObject, "level2"),
      },
      emailId: updateProfileWithNewResume?.Applicants?.emailId,
      contactNumber:
        updateProfileWithNewResume?.Applicants?.contactNumber ||
        updateProfileWithNewResume?.Applicants?.phone,
      alternateContactNumber:
        updateProfileWithNewResume?.Applicants?.alternateContactNumber || "",
      linkedIn: updateProfileWithNewResume?.linkedIn ?? "",
      location:
        updateProfileWithNewResume?.locationData?.formatted ?? "",
    };
    if (type === "update" && updateProfileWithNewResume !== null) {
      setDuplicateApplicatsConfirmPopup(false);
      setBreadCrumb(skipId, subpathName, "Applicant Code", additionalData);
      let obj = updateProfileWithNewResume;
      obj["sourceId"] = sourceId;
      obj["Resume"] = defaultFile;
      obj["applicantCode"] = applicantCode;
      delete obj.oldApplicantName;
      if (getApplicantPath().includes("applicants/list")) {
        const appliantObj = { id: skipId };
        dispatch(
          setSelectedApplicant({
            applicantDetails: appliantObj,
            aditionalState: {
              applicant: obj,
              isOverwriteEdit: true,
              isAssociatedApplicant,
            },
          }),
        );
        navigate(`/ats/layout/applicants/list/landing`, {
          state: { selectedApplicant: appliantObj },
        });
      } else {
        navigate(`/ats/layout/applicants/edit/${skipId}`, {
          state: {
            applicant: obj,
            isOverwriteEdit: true,
            isAssociatedApplicant,
          },
        });
      }
    } else if (type === "add" && skipId !== null) {
      setDuplicateApplicatsConfirmPopup(false);
      // updateProfileWithNewResume.oldApplicantName ? updateProfileWithNewResume.oldApplicantName :
      // setBreadCrumb(skipId, subpathName, 'Applicant Code', additionalData);
      const userInfo = await getUserDetails();
      const userData = await GetUserInfo();
      let formData = new FormData();
      formData.append("Resume", defaultFile);
      formData.append("id", skipId);
      formData.append("userId", userInfo.userId);
      formData.append("ResumeUserId", userInfo.id);
      formData.append("fileType", "Resume");
      formData.append("resumesourceId", sourceId.id);
      formData.append("resumesource", sourceId.name);
      formData.append("userFirstName", userInfo.firstName);
      formData.append("userLastName", userInfo.lastName);
      dispatch(_ser.uploadDocumentsAsync(skipId, formData, true));
    } else if (type === "skip" && skipId !== null) {
      // setDuplicateApplicatsConfirmPopup(false);
      // setBreadCrumb(skipId, subpathName, 'Applicant Code', additionalData);
      // updateProfileWithNewResume.oldApplicantName ? updateProfileWithNewResume.oldApplicantName :
      // navigate(`/ats/layout/applicants/view/${skipId}`);
      if (getApplicantPath().includes("applicants/list")) {
        // const appliantObj = { id: skipId };
        // dispatch(setSelectedApplicant({ applicantDetails: appliantObj }));
        window.open(`/ats/layout/applicants/list/landing/${skipId}`, "_blank");
      } else {
        window.open(`/ats/layout/applicants/view/${skipId}`, "_blank");
      }
    }
  };

  return (
    <section className="duplicatecustomModal">
      <div className="duplicatecustomModalDiv">
        <h1 className="modal-header">
          Duplicate Upload
          <span
            onClick={() => {
              setDuplicateApplicatsConfirmPopup(false);
            }}
          >
            <CloseIcon style={{ color: "#ff0000", cursor: "pointer" }} />
          </span>
        </h1>
        <div className="duplicatemodal-body">
          <h4>Please select from the following</h4>
          <div className="duplicateapplicanttabs">
            <div
              onClick={() => {
                onDuplicateUploadHandler("update");
              }}
            >
              <p>
                Update Profile <br />
                with new resume
              </p>
            </div>
            <div
              onClick={() => {
                onDuplicateUploadHandler("add");
              }}
            >
              <p>
                Add resume <br />
                on current profile
              </p>
            </div>
            {/* <div onClick={() => { onDuplicateUploadHandler("duplicate") }}><p>Upload anyways<br />with duplicate profile</p></div> */}
          </div>
          <div className="modalActionBtns">
            <Button
              type="button"
              className="cancelBtn"
              style={{ marginRight: "20px", width: "170px" }}
              onClick={() => {
                onDuplicateUploadHandler("skip");
              }}
            >
              View existing profile
            </Button>
            {/* <Link to={ componentLayout.navigateTo } className="cancelBtn"  style={{ marginRight: "20px", width: "170px" }} target='_blank' type="button">
                        View existing profile
            </Link> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApplicantsManualUploadPopup;
